import Headroom from 'headroom.js';
import dropdownEvent from '../base/_dropdownEvent.js';

export default class Header {
	constructor(node = '.header', opts = {}) {
		this.node = typeof node === 'string' ? document.querySelector( node ) : node;

		if ( ! this.node instanceof HTMLElement ) {
			return;
		}

		this.opts = Object.assign(
			{
				headroom: {
					tolerance: {
						up: 7,
						down: 5
					},
					classes: {
						initial  : 'header',
						pinned   : 'header--pinned',
						unpinned : 'header--unpinned',
						top      : 'header--top',
						notTop   : 'header--not-top',
						bottom   : 'header--bottom',
						notBottom: 'header--not-bottom',
						frozen   : 'header--frozen',
					}
				},
				search: '.header__search',
				menu: '.header__menu',
			},
			opts
		);

		if ( typeof this.opts.headroom === 'object' ) {
			// headroom
			this.headroom = new Headroom(this.node, this.opts.headroom);
			this.headroom.init();
			this.headroom.update(this.headroom);
		}

		this.search    = typeof this.opts.search === 'string' ? this.node.querySelectorAll(this.opts.search) : this.opts.search;
		this.hamburger = typeof this.opts.menu   === 'string' ? this.node.querySelector(this.opts.menu)   : this.opts.menu;

		// dropdowns
		const intentActivate = (e) => {
			Array.from( e.target.children ).filter( node => node.classList.contains( 'nav__menu' ) ).forEach( node => node.classList.add( 'nav__menu--visible') );
		}

		const intentDeactivate = (e) => {
			Array.from( e.target.children ).filter( node => node.classList.contains( 'nav__menu' ) ).forEach( node => node.classList.remove( 'nav__menu--visible') );
		}

		Array.from(this.node.querySelectorAll('.menu-item-has-children')).forEach((node) => {
			dropdownEvent(node);
			node.addEventListener('dropdown:activate', intentActivate);
			node.addEventListener('dropdown:deactivate', intentDeactivate);
		});

		this.node.addEventListener('click', (e) => {
			let node = e.target;

			while( node && node.parentNode ) {
				if ( node === this.node ) {
					return;
				}

				if ( node.matches( '.nav__menu--level-1 .menu-item-has-children > .nav__link' ) ) {
					e.preventDefault();
				}

				node = node.parentNode;
			}
		});
	}
}
